import { Button, Modal, Space, Typography, message } from "antd";
import { Requester, formatURL } from "api/requester";

import { API_END_POINTS } from "api/urls";
import { CheckCircleFilled } from "@ant-design/icons";
import { IProductItem } from "store/types";
import { LoansActions } from "store/slices/loansSlice";
import { RootState } from "store/store";
import { useAppDispatch } from "store/hooks";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const LoanDashboardDeliveryStatusForm = (props: {
  open: boolean;
  close: () => void;
}) => {
  const { t } = useTranslation();
  const { details } = useSelector(
    (state: RootState) => state.loans.loanDashboard
  );
  const dispatch = useAppDispatch();
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  const handleClose = () => {
    props?.close();
  };

  const handleSubmit = async () => {
    setIsSubmitLoading(true);
    const url = formatURL(API_END_POINTS.LOANS.markAsDelivered, {
      loanId: details?.id,
    });
    const data = {};
    const response = await Requester.post(url, data).catch(
      ({ response }) => response
    );
    if (response?.status === 204) {
      message.success(t("Successfully updated delivery status"));
      handleClose();
      dispatch(LoansActions.fetchLoanById(details?.id || ""));
    } else {
      message.error(t("Error while adding payment"));
    }
    setIsSubmitLoading(false);
  };
  return (
    <Modal
      open={props?.open}
      onCancel={props?.close}
      maskClosable={false}
      footer={[
        <Button
          type="primary"
          icon={<CheckCircleFilled />}
          onClick={handleSubmit}
          loading={isSubmitLoading}
        >
          {t("Mark as Delivered")}
        </Button>,
      ]}
    >
      <Typography.Text strong style={{ fontSize: 16 }}>
        {t("Mark the following items as delivered?")}
      </Typography.Text>
      <br />
      <Space direction="vertical">
        {details?.purchasedItems?.map((item: IProductItem) => {
          return (
            <Space key={item?.id} size={2}>
              <Typography.Text>{item?.name}</Typography.Text>
              <Typography.Text>{`(Quantity : ${item?.count})`}</Typography.Text>
            </Space>
          );
        })}
      </Space>
    </Modal>
  );
};

export default LoanDashboardDeliveryStatusForm;
